import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import ToggleSwitch from 'components/shared/ToggleSwitch/ToggleSwitch';

import { toggleClinicalNotesSwitchItems } from '../lib/helper';

import ClinicalNotesBase from './ClinicalTabs/ClinicalNotesBase';

const ExistingCNConfirm = ({
  patientId,
  setShowCreateConfirm,
  note,
  setNote,
  showLoadOrCreateConfirm,
  setShowLoadOrCreateConfirm
}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState('upcoming');

  const navigateToNote = () => {
    navigate(`/portal/charts/${patientId}/clinical-notes/${note.value}`);
  };

  const createNewNote = () => {
    setShowLoadOrCreateConfirm(false);
    setShowCreateConfirm(true);
  };

  const closeHandler = () => {
    setActive('upcoming');
    setNote({});
    setShowLoadOrCreateConfirm(false);
  };

  return (
    <Confirm
      handleOpen={showLoadOrCreateConfirm}
      handleClose={closeHandler}
      title="Select or Create a Clinical Note"
      icon="note-mono"
      isFooter={false}
      bodyClassName="!pb-[0px]">
      <p className="mb-5 whitespace-pre-line text-sm text-neutral-600">
        Choose from existing notes or create a new one. Today's note is selected by default if
        available.
      </p>
      <div className="mb-2">
        <ToggleSwitch
          active={active}
          onClick={() => {
            setActive(active === 'past' ? 'upcoming' : 'past');
            setNote({});
          }}
          items={toggleClinicalNotesSwitchItems}
        />
      </div>
      <div className="rounded-md border border-solid border-neutral-200">
        <div className="sticky top-0 grid grid-cols-[auto,1fr] rounded-md border border-b border-solid border-neutral-50 bg-white p-3">
          <p className="text-center font-600">Date of Service (DoS)</p>
        </div>

        <div className="max-h-56 overflow-y-auto">
          <ClinicalNotesBase
            note={note}
            setNote={setNote}
            queryType={active}
            setActive={setActive}
          />
        </div>
      </div>
      <div className="-mr-[12px] flex justify-end gap-x-3 pt-8">
        <Button
          outlined
          color="neutral"
          onClick={createNewNote}
          text="Create New Note"
          data-qa="close-confirm-modal-btn"
        />

        <Button
          data-qa="proceed-confirm-modal-btn"
          color="primary"
          text="Navigate to Note"
          disabled={!note?.value}
          onClick={navigateToNote}
        />
      </div>
    </Confirm>
  );
};

export default ExistingCNConfirm;
